const mail = {
    state: {
        mailId: '',
        draftId: '',
        pageType: '',
        mailType: '',
        currWriteType: '',
        mailData: null,
        mailIndex: null,
        largeAttachFreeSize: 0,
        indexListData: [],//邮件索引列表当前页索引数据
        checkedMails:[],//已选的邮件索引数据
        writeDataMd5: '',//写信草稿数据集Md5
        currDraftDataChange: false,
        acrossSelectCount: 0,
        acrossSelectFlag: false,
        indexListParams: null
    },
    mutations: {
        SET_MAIL_ID: (state, mailId) => {
            state.mailId = mailId;
        },
        SET_DRAFT_ID: (state, draftId) => {
            state.draftId = draftId;
        },
        SET_PAGE_TYPE: (state, pageType) => {
            state.pageType = pageType;
        },
        SET_MAIL_TYPE: (state, mailType) => {
            state.mailType = mailType;
        },
        SET_WRITE_TYPE: (state, currWriteType) => {
          state.currWriteType = currWriteType;
        },
        SET_MAIL_DATA: (state, mailData) => {
          state.mailData = mailData;
        },
        SET_MAIL_INDEX: (state, mailIndex) => {
          state.mailIndex = mailIndex;
        },
        SET_LARGE_FREESIZE: (state, largeAttachFreeSize) => {
          state.largeAttachFreeSize = largeAttachFreeSize;
        },
        SET_INDEX_DATA: (state, indexListData) => {
          state.indexListData = indexListData;
        },
        SET_CHECKED_MAILS: (state, checkedMails) => {
          state.checkedMails = checkedMails;
        },
        SET_WRITEDATA_MD5: (state, writeDataMd5) => {
          state.writeDataMd5 = writeDataMd5;
        },
        SET_CURRDRAFTDATA_CHANGE: (state, currDraftDataChange) => {
          state.currDraftDataChange = currDraftDataChange;
        },
        SET_ACROSS_COUNT: (state, acrossSelectCount) => {
          state.acrossSelectCount = acrossSelectCount;
        },
        SET_ACROSS_FLAG: (state, acrossSelectFlag) => {
          state.acrossSelectFlag = acrossSelectFlag;
        },
        SET_INDEXLIST_PARAMS: (state, indexListParams) => {
          state.indexListParams = indexListParams;
        }
    }
}

export default mail;



// WEBPACK FOOTER //
// ./src/store/modules/mail.js